import React from "react"
import { connect } from "react-redux"
import { updateSource } from "../../campaignCreationActions"
import GenericDropdown from "../../../common/components/genericDropdown"

class SourceAdTypeDropdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false,
      menuAnchorEl: null,
      menuItems: props.selectedSource.adTypes.map((adType) => {
        return {
          adType,
          name: adType.text,
        }
      }),
      selectedIndexesArr: [],
    }
  }

  handleMenuOpen = (event) => {
    this.setState({
      menuOpen: true,
      menuAnchorEl: event.currentTarget,
      menuItems: this.props.selectedSource.adTypes.map((adType) => {
        return {
          adType,
          name: adType.text,
        }
      }),
    })
  }

  handleMenuClose = () => {
    this.setState({
      menuOpen: false,
    })
  }

  handleMenuClick = (index) => {
    this.setState({
      selectedIndexesArr: index,
    })

    let newSourceData = Object.assign({}, this.props.selectedSource, {
      selectedAdTypesIndexesArr: index,
    })

    this.props.dispatch(updateSource(this.props.sourceKey, newSourceData))

    this.handleMenuClose()
  }

  render() {
    let buttonClassName = "creation-generic-dropdown-button "
    let header = "Choose Ad Type"
    let selectedAdType = this.props.selectedSource.adTypes.filter((adType) => adType.selected)
    if (selectedAdType.length > 0) {
      header = selectedAdType[0].text
    }

    return (
      <div className={"text-field"}>
        <div className="creation-generic-dropdown-label">Ad Type</div>
        <GenericDropdown
          header={header}
          selectOptionCallback={(index) => {
            this.handleMenuClick(index)
          }}
          options={this.state.menuItems}
          open={this.state.menuOpen}
          anchorEl={this.state.menuAnchorEl}
          selectedIndexes={this.state.selectedIndexesArr}
          openDropdownCallback={(event) => {
            this.handleMenuOpen(event)
          }}
          allowAutoSuggest={false}
          closeDropdownCallback={this.handleMenuClose}
          allowNoSelection={false}
          buttonClassName={buttonClassName}
          menuClassName={"creation-generic-dropdown-menu"}
        />
        {this.props.adTypeValidationErrors}
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    campaignSettings: state.campaignCreationWizard.campaignSettings,
  }
}

export default connect(mapStateToProps)(SourceAdTypeDropdown)
